import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Text, Button, BarGauge } from '@movember/mo-gel';
import { getRGBOpacity } from '@movember/mo-gel/utils/colors';
import { withTheme } from 'styled-components';

import { pushRouteChange } from '../../utils/gtmEventPush';

import {
  StyledOutcomesContainer,
  StyledButtonWrapper,
  StyledHighLevelInsightsContainer,
  StyledInsightsButtonContainer,
  StyledHighLevelInsightWrapper
} from './OutcomesCategory.styled';
import { formatDecimalToPercentage } from '../../utils/numbers';

class OutcomeCategory extends Component {
  handleOnViewLowLevel = (categoryLabel) => {
    pushRouteChange(categoryLabel, 'results');

    const { onViewLowLevel } = this.props;
    return onViewLowLevel(categoryLabel);
  };

  reverseColorMapping = () => {
    const { theme } = this.props;
    const { colors } = theme;
    return [
      {
        min: 0,
        max: 20,
        color: colors.success3
      },
      {
        min: 21,
        max: 40,
        color: colors.success2
      },
      {
        min: 41,
        max: 60,
        color: colors.success1
      },
      {
        min: 61,
        max: 80,
        color: colors.warning300
      },
      {
        min: 81,
        max: 100,
        color: colors.warning500
      }
    ];
  };

  render() {
    const { category, theme } = this.props;

    return (
      <StyledOutcomesContainer tag="li" margin="0" borderCollapse shadow="shadow300">
        <Text color={getRGBOpacity(theme.colors.primaryFont, 0.5)}>{category.categoryName.toUpperCase()}</Text>
        <StyledInsightsButtonContainer>
          <StyledHighLevelInsightsContainer>
            {category.highLevelInsights.map((insight, highLevelIndex) => {
              return (
                <StyledHighLevelInsightWrapper key={`highLevelInsight-${highLevelIndex}`} direction="row">
                  <BarGauge
                    heading={`${insight.label}`}
                    value={formatDecimalToPercentage(insight.reversed ? 100 - insight.score : insight.score)}
                    maxValue={100}
                    unit=""
                    leftLabel={insight.reversed ? insight.maxLabel : insight.minLabel}
                    rightLabel={insight.reversed ? insight.minLabel : insight.maxLabel}
                  />
                </StyledHighLevelInsightWrapper>
              );
            })}
          </StyledHighLevelInsightsContainer>

          <StyledButtonWrapper data-track-type="Explore insights" data-track-location={category.categoryName}>
            <Button
              primary
              onClick={() => this.handleOnViewLowLevel(category.categoryName)}
              data-track-type="Explore insights"
              data-track-location={category.categoryName}
            >
              Explore insights
            </Button>
          </StyledButtonWrapper>
        </StyledInsightsButtonContainer>
      </StyledOutcomesContainer>
    );
  }
}

const OutcomeCategoryWrapper = withTheme(OutcomeCategory);
export { OutcomeCategoryWrapper as OutcomeCategory };

const InsightObject = () => {
  InsightObject.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    score: PropTypes.number,
    phrase: PropTypes.string
  };
};

const CategoryObject = () => {
  CategoryObject.propTypes = {
    categoryName: PropTypes.string,
    highLevelInsights: PropTypes.arrayOf(InsightObject),
    lowLevelInsights: PropTypes.arrayOf(InsightObject)
  };
};

OutcomeCategory.defaultProps = {
  category: null,
  onViewLowLevel: () => {}
};

OutcomeCategory.propTypes = {
  category: PropTypes.objectOf(CategoryObject),
  onViewLowLevel: PropTypes.func
};
